import { Component, Input } from "@angular/core";

import { PositionOption } from "@lantern/app/core/utils/overlays/position-strategies";

import { TooltipMessage } from "./tooltip.component";

export const DEFAULT_TOOLTIP_ICON: string = "help-circled";

@Component({
  selector: "ta-tooltip-icon",
  template: `
    <ta-icon
      [icon]="icon"
      [taTooltipStatic]="message"
      [tooltipPositionOptions]="positionOptions"
    ></ta-icon>
  `
})
export class TooltipIconComponent {
  @Input()
  message?: TooltipMessage;

  @Input()
  get icon(): string {
    return this._icon;
  }
  set icon(value: string) {
    if (value == null || value === this._icon) {
      return;
    }
    this._icon = value;
  }
  private _icon: string = DEFAULT_TOOLTIP_ICON;

  @Input()
  get positionOptions(): PositionOption[] {
    return this._positionOptions;
  }
  set positionOptions(value: PositionOption[]) {
    if (value == null || value === this._positionOptions) {
      return;
    }
    this._positionOptions = value;
  }
  _positionOptions: PositionOption[] = ["top", "right", "bottom", "left"];
}
